import {mapActions, mapGetters, mapMutations} from "vuex";
import productClickMixin from '@/mixins/productClickMixin';
import productAddToCartMixin from '@/mixins/productAddToCartMixin';
import {
    addToCompare,
    isInCompareList,
    removeFromCompare,
    snapshotFromCardItem
} from '@/utils/compareList';
import bellRingingIcon from '@/assets/images/bell-ringing.svg';

export default {
    name: "product-card",
    mixins: [productClickMixin, productAddToCartMixin],
    props: {
        item: {
            type: Object,
            default: () => {
            }
        },
        isLoad: false
    },
    data() {
        return {
            clickCount: 0,
            favoritesVersion: 0,
            compareVersion: 0,
            bellRingingIcon
        }
    },
    computed: {
        ...mapGetters({
            currentProduct: 'catalog/currentProduct',
        }),
        productStatusColor() {
            if (this.item.productStatus.key === 'in_stock') {
                return '#5ED84B'
            }
            if (this.item.productStatus.key === 'not_available') {
                return '#0e3ab6'
            }
            if (this.item.productStatus.key === 'order') {
                return '#171616'
            }
        },
        oldPrice() {
            const productPrice = this.item.productPrice

            if (!productPrice.hasDiscount) {
                return '';
            }
            const unit = productPrice.baseUnit.title
            const rawPrice = this.resolveUnitPrice(
                productPrice.priceOld,
                productPrice.baseUnit.isM2
            )
            const price = Number(rawPrice)
            if (!Number.isFinite(price) || price <= 0) {
                return ''
            }
            return `${new Intl.NumberFormat('uk').format(price)} грн/${unit}`
        },
        currentPrice() {
            const productPrice = this.item.productPrice
            const unit = productPrice.baseUnit.title

            const rawPrice = this.resolveUnitPrice(
                productPrice.price,
                productPrice.baseUnit.isM2
            )
            const price = Number(rawPrice)

            if (!Number.isFinite(price) || price <= 0) {
                return 'Ціну уточнюйте'
            }
            return `${new Intl.NumberFormat('uk').format(price)} грн/${unit}`
        },
        discountLabel() {
            const productPrice = this.item.productPrice;
            if (!productPrice.hasDiscount) {
                return '';
            }
            const currentPrice = this.resolveUnitPrice(
                productPrice.price,
                productPrice.baseUnit.isM2
            );
            const oldPrice = this.resolveUnitPrice(
                productPrice.priceOld,
                productPrice.baseUnit.isM2
            );
            if (!oldPrice || oldPrice <= currentPrice) {
                return '';
            }
            const discountPercent = ((oldPrice - currentPrice) / oldPrice) * 100;
            return `-${Math.round(discountPercent)} %`;
        },
        ratingValue() {
            const rating = this.item?.rating
                || this.item?.productRating
                || this.item?.averageRating
                || this.item?.reviewsRating
                || this.item?.reviews?.rating;
            const parsed = Number(rating);
            if (!Number.isFinite(parsed) || parsed <= 0) {
                return '';
            }
            return parsed.toFixed(1);
        },
        reviewCount() {
            const reviews = this.item?.reviewsCount
                || this.item?.reviewCount
                || this.item?.commentsCount
                || this.item?.feedbackCount
                || this.item?.reviews?.count;
            const parsed = Number(reviews);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
        },
        stikyes() {
            let stikies = [];
            const productPrice = this.item.productPrice;
            if(productPrice.hasDiscount){
                let currprice = this.resolveUnitPrice(
                    productPrice.price,
                    productPrice.baseUnit.isM2
                );

                let oldprice = this.resolveUnitPrice(
                    productPrice.priceOld,
                    productPrice.baseUnit.isM2
                );
                let percent = ((oldprice - currprice) / oldprice) * 100;
                percent = Math.round(percent * 10) / 10;
                let discontLabel = {
                    id: 99999,
                    label_color: '#e93f11',
                    title: '-' + percent + '%'
                };
                stikies.push(discontLabel);
            }
            let thisLabels = this.item.labels.data;
            if(thisLabels && Array.isArray(thisLabels)){
                thisLabels.map(function(item){
                    let labelItem = {
                        id: item.id,
                        label_color: item.labelColor,
                        title: item.title
                    };
                    stikies.push(labelItem);
                });
            }
            return stikies.reverse();
        }
    },
    created() {
    },
    mounted() {
        // Ініціалізуємо відстеження кліків для цього товару
        this.initProductClickTracker('Product Card', 'product-card');
        // Глобальний трекер створюється в міксині, тут нічого не робимо
        window.addEventListener('storage', this.onFavoritesStorage)
        window.addEventListener('favorites-updated', this.onFavoritesUpdated)
        window.addEventListener('compare-updated', this.onCompareUpdated)
    },
    beforeDestroy() {
        window.removeEventListener('storage', this.onFavoritesStorage)
        window.removeEventListener('favorites-updated', this.onFavoritesUpdated)
        window.removeEventListener('compare-updated', this.onCompareUpdated)
    },
    destroyed() {
    },
    methods: {
        ...mapMutations({
            addToBasket: `basket/ADD_ITEM_TO_BASKET`,
            showAvailabilityNotifyPopup: 'order/SHOW_AVAILABILITY_NOTIFY_POPUP',
            setProductForAvailabilityNotify: 'order/SET_PRODUCT_FOR_AVAILABILITY_NOTIFY',
        }),
        ...mapActions({
            getCurrentProduct: 'catalog/GET_PRODUCT',
            basketProductAction: 'basket/BASKET_PRODUCT_ACTION',
        }),
        resolveUnitPrice(priceBlock, isM2) {
            if (!priceBlock) {
                return Number.NaN
            }
            const primary = isM2 ? priceBlock.priceM2 : priceBlock.price
            const fallback = priceBlock.price
            const raw = primary != null && primary !== '' ? primary : fallback
            const price = Number(raw)
            return Number.isFinite(price) ? price : Number.NaN
        },
        onFavoritesStorage(event) {
            if (event.key === 'favorites') {
                this.favoritesVersion += 1
            }
            if (event.key === 'productCompare') {
                this.compareVersion += 1
            }
        },
        onFavoritesUpdated() {
            this.favoritesVersion += 1
        },
        onCompareUpdated() {
            this.compareVersion += 1
        },
        getFavoritesList() {
            try {
                const list = JSON.parse(localStorage.getItem('favorites'))
                return Array.isArray(list) ? list : []
            } catch (e) {
                return []
            }
        },
        isFavorite(productId) {
            this.favoritesVersion
            return this.getFavoritesList().some((el) => String(el.id) === String(productId))
        },
        isInCompare(productId) {
            this.compareVersion
            return isInCompareList(productId)
        },
        toggleCompare(item) {
            if (isInCompareList(item.id)) {
                removeFromCompare(item.id)
                this.compareVersion += 1
                return
            }
            const snapshot = snapshotFromCardItem(item)
            const result = addToCompare(snapshot)
            if (!result.ok) {
                if (result.message) {
                    this.$toasted.warning(result.message)
                }
                return
            }
            this.compareVersion += 1
            window.dispatchEvent(new CustomEvent('compare-product-added', {
                detail: {
                    product: result.item,
                    count: result.count
                }
            }))
        },
        toggleFavorite(item) {
            const favorites = this.getFavoritesList()
            const index = favorites.findIndex((el) => String(el.id) === String(item.id))
            if (index > -1) {
                favorites.splice(index, 1)
            } else {
                favorites.push({
                    id: item.id,
                    slug: item.slug,
                    title: item.title,
                    image: item.image
                })
            }
            localStorage.setItem('favorites', JSON.stringify(favorites))
            this.favoritesVersion += 1
            window.dispatchEvent(new CustomEvent('favorites-updated'))
        },
        addBasket() {
            if (this.item.inStock) {
                // Відстежуємо додавання в кошик негайно, не чекаючи мережевого запиту
                // ВИПРАВЛЕННЯ: завжди використовуємо item, щоб уникнути проблеми з currentProduct
                const productForTracking = this.item;
                // Перевіряємо, чи є валідні дані товару для відстеження
                if (productForTracking && productForTracking.id) {
                    this.trackAddToCart(productForTracking, 1);
                } else {
                    console.warn('Cannot track add to cart: missing product data', {
                        currentProduct: this.currentProduct,
                        item: this.item,
                        productForTracking: productForTracking
                    });
                }
                this.getCurrentProduct(this.item.slug).then(() => {
                    this.basketProductAction({type: 'increment', product_id: this.currentProduct.id})
                    window.dispatchEvent(new CustomEvent('open-basket-modal', {
                        detail: {
                            productId: this.currentProduct.id
                        }
                    }))
                })
            }
        },
        notifyWhenInStock() {
            this.setProductForAvailabilityNotify({
                product: this.item
            })
            this.showAvailabilityNotifyPopup(true)
        },
        changeImage(item, ref) {
            if (item.secondImage) {
                let test = this.$refs[ref]
                if (test) {
                    test.classList.add('fade')
                    test.setAttribute('src', item.secondImage)
                }
            }
        },
        deleteImage(item, ref) {
            let test = this.$refs[ref]
            if (test) {
                test.classList.remove('fade')
                test.setAttribute('src', item.image)
            }
        },
        /**
         * Тестовий метод для перевірки кліків на div.card
         */
        testDivClick(item) {
            return item
        },
        /**
         * Обробляє клік по картці товару, виключаючи кліки по кнопках
         * @param {Event} event - Подія кліку
         * @param {Object} item - Дані товару
         */
        handleCardClick(event, item) {
            // Перевіряємо, чи клік був по button__wrapper або його дочірніх елементах
            if (event.target.closest('.button__wrapper')) {
                return;
            }
            
            // Перевіряємо, чи клік був по елементах з data-exclude-tracking
            if (event.target.closest('[data-exclude-tracking="true"]')) {
                return;
            }
            
            // Цей метод викликається тільки для router-link (фото/название)
            // Відстежуємо клік по картці товару - тепер завжди відправляємо select_item
            if (typeof this.handleProductClick === 'function') {
                this.handleProductClick(item);
            } else {
                console.error('❌ this.handleProductClick не є функцією!', this.handleProductClick);
            }
            
            // Виконуємо навігацію вручну
            this.$router.push(this.$localize({name:'product', params:{slug: item.slug}}));
        }
    },
}
